import { render, staticRenderFns } from "./inputProjectsTeam.vue?vue&type=template&id=0ac1cf39&"
import script from "./inputProjectsTeam.vue?vue&type=script&lang=js&"
export * from "./inputProjectsTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports